import { render, staticRenderFns } from "./ExerciseAttemptReview.vue?vue&type=template&id=16e0cbc2&scoped=true"
import script from "./ExerciseAttemptReview.vue?vue&type=script&lang=js"
export * from "./ExerciseAttemptReview.vue?vue&type=script&lang=js"
import style0 from "./ExerciseAttemptReview.vue?vue&type=style&index=0&id=16e0cbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0cbc2",
  null
  
)

export default component.exports